import { createRpcClientV2 } from 'rpc-client-utils';
import httpClient from 'hub-http/clients/apiClient';
export const rpcClient = createRpcClientV2({
  hubHttpClient: httpClient
});